export default __webpack_public_path__ + "static/media/create-trustline-step-3.af38ef0e.png";